// Утилита для получения конфигурации из runtime JSON
let runtimeConfig = null;

// Загружаем runtime конфигурацию
export const loadRuntimeConfig = async () => {
  if (runtimeConfig) return runtimeConfig;
  
  try {
    const response = await fetch('/runtime-config.json');
    if (response.ok) {
      runtimeConfig = await response.json();
      return runtimeConfig;
    }
  } catch (error) {
    console.warn('Failed to load runtime config:', error);
  }
  
  return null;
};

export const getConfig = async (key) => {
  // Загружаем runtime конфигурацию
  const config = await loadRuntimeConfig();
  
  // Если есть runtime конфигурация, используем её
  if (config && config[key]) {
    return config[key];
  }
  
  // Для runtime переменных не используем process.env fallback
  const runtimeVariables = ['REACT_APP_FEEDBACK_API_URL'];
  if (runtimeVariables.includes(key)) {
    return null;
  }
  
  // Fallback на build-time переменные (только если process доступен)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  
  return null;
};

// Синхронная версия для совместимости
export const getConfigSync = (key) => {
  // Сначала проверяем runtime конфигурацию (если уже загружена)
  if (runtimeConfig && runtimeConfig[key]) {
    return runtimeConfig[key];
  }
  
  // Для runtime переменных не используем process.env fallback
  const runtimeVariables = ['REACT_APP_FEEDBACK_API_URL'];
  if (runtimeVariables.includes(key)) {
    return null;
  }
  
  // Fallback на build-time переменные (только если process доступен)
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }
  
  return null;
};

// Удобные геттеры для часто используемых переменных
export const getFeedbackApiUrl = () => getConfigSync('REACT_APP_FEEDBACK_API_URL');
export const getFeedbackApiUrlAsync = () => getConfig('REACT_APP_FEEDBACK_API_URL'); 